export default "<app-menu></app-menu>\r\n";